import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import SelfRegisteredRoute from '@/components/common/SelfRegisteredRoute';

import { NotFoundPage } from '@/pages/NotFoundPage';
import GameLayout from './layouts/GameLayout';
import MainLayout from './layouts/MainLayout';
import DashboardLayout from './layouts/DashboardLayout';
import {
  AccountStatementPage,
  ActivityLogsPage,
  ChangePasswordPage,
  BetHistoryPage,
  HomePage,
  InplayPage,
  MarketsPage,
  MultiMarketPage,
  SportsPage,
  TermsConditionsPage,
  CasinoPage,
  QTECHLobbyPage,
  CasinoPlaygroundPage,
  CasinoBetHistoryPage,
  ProfitLossPage,
  ReferralPage,
  Dashboard,
  ProfilePage,
  StackSetting,
  ProfitLoss,
} from '@/routes';
import { ScrollToTop } from '@/utils/ScrollToTop';
import CasinoLayout from './layouts/CasinoLayout';
import MaintenancePage from './pages/MaintenancePage';

export function App() {
  if (import.meta.env.VITE_MAINTENANCE_MODE === 'true') {
    return (
      <Routes>
        <Route path="*" element={<MaintenancePage />} />
      </Routes>
    );
  }
  // Dashboard /icons/new/casino.png
  return (
    <>
      <ScrollToTop />
      {/* <SupportButton /> */}
      <Routes>
        {/* Auth Routes */}
        {/* <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
        </Route> */}
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          <Route path="/home" element={<HomePage />} />
          <Route path="/inplay" element={<InplayPage />} />
          <Route path="/all-sports/:sportName" element={<SportsPage />} />
          {/* <Route path="/user/casino-results" element={<CasinoResultsPage />} /> */}
          {/* <Route path="/user/live-casino-bets" element={<LiveCasinoBetsPage />} /> */}
          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/user/account-statement" element={<AccountStatementPage />} />
            <Route path="/user/profile" element={<ProfilePage />} />
            <Route path="/user/stack-setting" element={<StackSetting />} />
            <Route path="/user/bet-history" element={<BetHistoryPage />} />
            <Route path="/user/profit-loss" element={<ProfitLossPage />} />
            <Route path="/user/activity-logs" element={<ActivityLogsPage />} />
            <Route path="/user/casino-bet-history" element={<CasinoBetHistoryPage />} />
            <Route path="/user/change-password" element={<ChangePasswordPage />} />
            <Route path="/user/profit-loss" element={<ProfitLoss />} />
            <Route element={<SelfRegisteredRoute />}>
              <Route path="/referral" element={<ReferralPage />} />
            </Route>
          </Route>
        </Route>
        <Route element={<CasinoLayout />}>
          <Route path="/casino" element={<CasinoPage />} />
          <Route path="/casino-playground" element={<CasinoPlaygroundPage />} />
          <Route path="/casino-qtech" element={<QTECHLobbyPage />} />
        </Route>
        <Route element={<GameLayout />}>
          <Route path="/game-details/:sportName/:eventId" element={<MarketsPage />} />
          <Route path="/multi-market" element={<MultiMarketPage />} />
        </Route>

        {/* 404 */}
        <Route path="/terms-and-conditions" element={<TermsConditionsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
